'use strict';

var _ = require('lodash');
var DataExtractFilterGridController = function DataExtractFilterGridController($scope, SearchCriteriaBuilder, angularHelper) {
  var index;
  var searchCriteriaBuilder;
  function clearValues() {
    index = 0;
    $scope.appliedFilters = [];
  }
  $scope.init = function () {
    if (!$scope.appliedFilters || $scope.appliedFilters.length === 0) {
      clearValues();
    } else {
      index = getNextAvailableIndex();
    }
    searchCriteriaBuilder = new SearchCriteriaBuilder($scope.appliedFilters);
    if ($scope.treeGridAdapter) {
      $scope.treeGridAdapter.init(searchCriteriaBuilder);
      $scope.treeGridAdapter.expandAll();
      triggerAutomatedFormatFilters();
    }
  };
  $scope.levelChangedHandler = function () {
    cancelEditing();
    $scope.isEditing = false;
    clearValues();
    $scope.init();
  };
  function getSelection() {
    return $scope.treeGridAdapter ? _.sortBy($scope.treeGridAdapter.getSelection(), 'index') : [];
  }
  function setSelection(id) {
    return $scope.treeGridAdapter.setSelection(id);
  }
  function updateDataInGrid() {
    searchCriteriaBuilder.assertContinuousIndexes();
    $scope.treeGridAdapter.updateBoundData();
    $scope.treeGridAdapter.sortByIndex();
    $scope.treeGridAdapter.expandAll();
    triggerAutomatedFormatFilters();
    //To update buttons visibility
    angularHelper.triggerApply($scope);
  }
  function triggerAutomatedFormatFilters() {
    _.each(searchCriteriaBuilder.getFilledFilterInputIds(), $scope.treeGridAdapter.markRowAsEdited);
  }
  function isInEditingState() {
    return $scope.isEditing;
  }
  $scope.groupAvailable = function () {
    return searchCriteriaBuilder && !searchCriteriaBuilder.isGroupingDisabled(getSelection()) && !isInEditingState();
  };
  $scope.group = function () {
    if ($scope.groupAvailable()) {
      searchCriteriaBuilder.createGroup(getSelection());
      updateDataInGrid();
    }
  };
  $scope.ungroupAvailable = function () {
    return searchCriteriaBuilder && !searchCriteriaBuilder.isUngroupingDisabled(getSelection()) && !isInEditingState();
  };
  $scope.ungroup = function () {
    if ($scope.ungroupAvailable()) {
      searchCriteriaBuilder.ungroup(getSelection());
      updateDataInGrid();
    }
  };
  $scope.removeElementAvailable = function () {
    return searchCriteriaBuilder && !searchCriteriaBuilder.isDeleteDisabled(getSelection()) && !isInEditingState();
  };
  $scope.removeElement = function () {
    if ($scope.removeElementAvailable()) {
      searchCriteriaBuilder.deleteRows(getSelection());
      updateDataInGrid();
    }
  };
  $scope.moveUpElementAvailable = function () {
    return searchCriteriaBuilder && !searchCriteriaBuilder.isMoveUpDisabled(getSelection()) && !isInEditingState();
  };
  $scope.moveUpElement = function () {
    if ($scope.moveUpElementAvailable()) {
      var selection = getSelection();
      var selectedId = selection[0].id;
      searchCriteriaBuilder.moveUp(selection);
      updateDataInGrid();
      setSelection(selectedId);
    }
  };
  $scope.moveDownElementAvailable = function () {
    return searchCriteriaBuilder && !searchCriteriaBuilder.isMoveDownDisabled(getSelection()) && !isInEditingState();
  };
  $scope.moveDownElement = function () {
    if ($scope.moveDownElementAvailable()) {
      var selection = getSelection();
      var selectedId = selection[0].id;
      searchCriteriaBuilder.moveDown(selection);
      updateDataInGrid();
      setSelection(selectedId);
    }
  };
  var getNextAvailableIndex = function getNextAvailableIndex() {
    if ($scope.appliedFilters.length > 0) {
      return $scope.appliedFilters[$scope.appliedFilters.length - 1].index + 1;
    }
    return index;
  };
  var finishEditing = function finishEditing() {
    //Temporary ignore validation to pass validation and end edit row if any is selected
    var selection = getSelection();
    if (selection && selection.length > 0) {
      var selectedId = selection[0].id;
      searchCriteriaBuilder.ignoreValidation(selectedId);
      $scope.treeGridAdapter.markRowAsEdited(selectedId);
      searchCriteriaBuilder.unignoreValidation(selectedId);
    }
  };
  var cancelEditing = function cancelEditing() {
    var selection = getSelection();
    if (selection && selection.length > 0) {
      var selectedId = selection[0].id;
      $scope.treeGridAdapter.cancelEditing(selectedId);
    }
  };
  $scope.addAppliedFilterHandler = function (event, item) {
    if (isInEditingState()) {
      finishEditing();
    }
    searchCriteriaBuilder.appendField({
      'id': searchCriteriaBuilder.getNextAvailableId(),
      'index': getNextAvailableIndex(),
      'name': item.name,
      'inputFilter': '',
      'availableFilters': _.map(item.availableFilters, function (d) {
        return {
          id: d
        };
      }),
      'type': item.type,
      'dbPath': item.dbPath
    });
    updateDataInGrid();
  };
};
DataExtractFilterGridController.$inject = ['$scope', 'SearchCriteriaBuilderFactory', 'AngularHelper'];
module.exports = DataExtractFilterGridController;